<template lang="pug">

    div

        //- Name
        text-field(label='Name' v-bind:isRequired='true' v-model='name')
            error(:$v='$v.name' validator='required')
                | Darf nicht leer sein. Bitte einen gültigen Namen angeben

        //- Freitext #1
        text-field(v-if='company.freeText1' v-bind:label='company.freeText1' v-model='freeText1')

        //- Freitext #2
        text-field(v-if='company.freeText2' v-bind:label='company.freeText2' v-model='freeText2')

        //- Freitext #3
        text-field(v-if='company.freeText3' v-bind:label='company.freeText3' v-model='freeText3')

</template>

<script>
    import { required } from 'vuelidate/lib/validators'
    import { validate_composite } from '@/utils/validate'
    import Error from '@/components/form/FieldError.vue'
    import NumberField from '@/components/form/NumberField.vue'
    import TextField from '@/components/form/TextField.vue'
    import * as R from "ramda";

    //noinspection ReservedWordAsName
    export default {

        components: { Error, NumberField, TextField },

        computed: {
            freeText1: {
                get() { return this.value.freeText1 },
                set(value) { this.updateValue('freeText1', value) }
            },
            freeText2: {
                get() { return this.value.freeText2 },
                set(value) { this.updateValue('freeText2', value) }
            },
            freeText3: {
                get() { return this.value.freeText3 },
                set(value) { this.updateValue('freeText3', value) }
            },
            name: {
                get() { return this.value.name },
                set(value) { this.updateValue('name', value) }
            }
        },

        methods: {

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

            validate: validate_composite

        },

        props: {
            company: {
                type: Object,
                required: true
            },
            value: {
                type: Object,
                required: true
            }
        },

        validations: {
            name: { required },
        },

    }

</script>
